import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import flowerPackageService from "../../service/flower-package";
import { FlowerPackageState, UpdateFlowerPackage } from "../../@type/flower-packages";



export const getFlowerPackage = createAsyncThunk(
    "get/getFlowerPackage",
    async (id: number) => {
      const { data } = await flowerPackageService.get(id);
      return data;
    }
  );
      export const updateFlowerPackage = createAsyncThunk(
    "flowerPackage/updateFlowerPackage",
    async ({ packageId, oldFlowerId, newFlowerId }: UpdateFlowerPackage) => {
      const { data } = await flowerPackageService.update(packageId, oldFlowerId, newFlowerId);
      return data;
    }
  );
const initialState: FlowerPackageState = {
  flowerPackageList: [],
  flowerPackageDetail: {
    id: 0,
    type:"",
    count:"",
    flowers:[],
  }
};

const FlowerPackageSlice = createSlice({
  name: "FlowerPackage ",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getFlowerPackage.fulfilled, (state, action) => {
      state.flowerPackageDetail = action.payload;
    });
    builder.addCase(updateFlowerPackage.fulfilled, (state, action) => {
      state.flowerPackageDetail = action.payload;
    });

  },
});

export default FlowerPackageSlice.reducer;
